/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { getAPI } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Space, Button, Card, Layout, Table, Tag, Input } from "antd";
import { ALL_ORDERS } from "../../constants/api";
import { CURRENCY } from "../../constants/constent";
import dayjs from "dayjs";

function OrderAcceptTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const rData = data["data"]
          .filter((row) => row.status === "Accept")
          .map((row, index) => ({
            key: index,
            id: index + 1,
            gen_order_id: row.gen_order_id,
            name: row.user.name,
            mobile: row.user.mobile,
            total_bill: `${CURRENCY} ${row.total_bill}`,
            total_items: row.total_items,
            total_items_tag: <Tag color={`success`}>{row.total_items}</Tag>,
            status: row.status,
            payment_by: row.payment_by,
            payment_status: row.payment_status,
            order_date: dayjs(row.order_date).format("DD-MM-YYYY"),
            total_bill_tag: (
              <span>
                <Tag
                  color={row.payment_status === "Success" ? `success` : `error`}
                >{`${CURRENCY} ${row.total_bill}`}</Tag>
              </span>
            ),
            status_tag: (
              <span>
                <Tag color={row.status === "Delivered" ? `success` : `error`}>
                  {row.status}
                </Tag>
              </span>
            ),
            action: (
              <Space>
                <Button
                  loading={loading}
                  disabled={loading}
                  onClick={() => {
                    navigate("/order/view/" + row.gen_order_id);
                  }}
                  block
                >
                  View
                </Button>
              </Space>
            ),
          }));
        setState(rData);
        setFilteredData(rData);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_ORDERS, successFn, errorFn, {});
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room.gen_order_id.toLowerCase().includes(value.toLowerCase()) ||
        room.name.toLowerCase().includes(value.toLowerCase()) ||
        room.payment_by.toLowerCase().includes(value.toLowerCase()) ||
        room.order_date.toLowerCase().includes(value.toLowerCase()) ||
        room.status.toLowerCase().includes(value.toLowerCase()) ||
        room.payment_status.toLowerCase().includes(value.toLowerCase()) ||
        room.order_date.toString().includes(value) ||
        room.mobile.toString().includes(value)
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "id",
      width: 50,
    },
    {
      title: "Order ID",
      dataIndex: "gen_order_id",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "name",
      width: 50,
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      width: 50,
    },
    {
      title: "Items",
      dataIndex: "total_items_tag",
      width: 50,
    },
    {
      title: "Order Date",
      dataIndex: "order_date",
      width: 150,
    },
    {
      title: "Bill",
      dataIndex: "total_bill_tag",
      width: 50,
    },
    {
      title: "Payment By",
      dataIndex: "payment_by",
      width: 50,
    },
    {
      title: "Status",
      dataIndex: "status_tag",
      width: 50,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Accept Orders"
            extra={
              <Space>
                <Input
                  placeholder="Search by Name or Order ID"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default OrderAcceptTable;
